module.exports = require("./ms-SG");